import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getBillingSubscriptionInfo({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.billing.subscription.get, signal });

    const result = data.results?.[0] || data.result || data || {};
    yield put(actions.getBillingSubscriptionInfoDone(result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBillingSubscriptionInfoFailed,
      endpoint: api.billing.subscription.get.url
    });
  }
}

export const getBillingSubscriptionInfoSaga = takeEvery(types.GET_BILLING_SUBSCRIPTION_INFO_REQUEST, getBillingSubscriptionInfo);